import { defineMessages } from "react-intl";

export const messages = defineMessages({
  "values.header.back": {
    id: "values.header.back",
    defaultMessage: "Back to the dashboard",
  },
  "values.set.heading": {
    id: "values.set.heading",
    defaultMessage: "Select the values that you believe in the most",
  },
  "values.set.perex": {
    id: "values.set.perex",
    defaultMessage:
      "Your values are a central part of who you are. Choose 3 to 5 values that you believe in the most. When your words align with your actions and values, you'll feel confident in your authentic self.",
  },
  "values.set.aside.title": {
    id: "values.set.aside.title",
    defaultMessage: "My values",
  },
  "values.set.aside.save": {
    id: "values.set.aside.save",
    defaultMessage: "Save my values",
  },
  "values.aside.title": {
    id: "values.aside.title",
    defaultMessage: "My values",
  },
  "values.aside.perex": {
    id: "values.aside.perex",
    defaultMessage: "History",
  },
  "values.aside.save": {
    id: "values.aside.save",
    defaultMessage: "Change my values",
  },
  "values.heading": {
    id: "values.heading",
    defaultMessage: "Here are my values",
  },
  "values.perex": {
    id: "values.perex",
    defaultMessage:
      "Your values are a central part of who you are. When what you say matches your actions and values, you\u2019ll feel confident that you are putting forth an authentic you.",
  },
  "values.card.summary": {
    id: "values.card.summary",
    defaultMessage: "Click on your value to understand more about it.",
  },
});
